export default __webpack_public_path__ + "static/media/logo.ca527ec9.png";